/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import axios from 'axios';
export default class Header extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: null,
      loading: false,
      path: window.location.pathname,
    };
  }

  componentDidMount() {
    axios.get('/api/v1/meta').then(({ data }) => {
      if (data.success) {
        this.setState({
          user: data.payload.user,
        });
      }
      this.setState({
        loading: true,
      });
    });
  }

  handleLogout = (e) => {
    e.preventDefault();
    axios.get('/api/v1/logout').then(({ data }) => {
      if (data.success) {
        window.location.href = '/';
      }
    });
  };

  render() {
    const { user, loading, path } = this.state;
    return (
      <header>
        <nav
          className='navbar navbar-expand-lg'
          style={{ padding: '0 9.375vw' }}
        >
          <button className='navbar-toggler' type='button'>
            <span className='navbar-toggler-icon'></span>
          </button>
          <a className='logo' href='/'>
            <img src='/assets/img/logo.png' alt='' />
          </a>
          <div className='navbar-collapse'>
            <ul className='navbar-nav'>
              <li>
                <a href='/' title='' className={path === '/' ? 'active' : ''}>
                  Trang chủ
                </a>
              </li>
              <li>
                <a
                  href='/nen-tang-so'
                  title=''
                  className={path === '/nen-tang-so' ? 'active' : ''}
                >
                  Nền tảng đồng hành
                </a>
              </li>
              <li>
                <a
                  href='/tin-tuc'
                  title=''
                  className={path === '/tin-tuc' ? 'active' : ''}
                >
                  Tin tức
                </a>
              </li>
              <li>
                <a
                  href='/huong-dan-su-dung'
                  title=''
                  className={path === '/huong-dan-su-dung' ? 'active' : ''}
                >
                  Hướng dẫn sử dụng
                </a>
              </li>
            </ul>
            <div className='col-md-2 col-sm-12 account-login'>
              {user ? (
                <div className='dropdown show account-profile'>
                  <a
                    className='btn-white dropdown-toggle'
                    role='button'
                    id='dropdownMenuLink'
                    data-toggle='dropdown'
                    aria-haspopup='true'
                    aria-expanded='false'
                  >
                    <strong>{`Xin chào, ${
                      user.company
                        ? user.company.name.substr(0, 5)
                        : user.name.substr(0, 5)
                    } `}</strong>
                  </a>

                  <div
                    className='dropdown-menu dropdown-menu-right'
                    aria-labelledby='dropdownMenuLink'
                  >
                    <a href='/bang-dieu-khien' className='dropdown-item'>
                      Bảng điều khiển
                    </a>
                    <button
                      className='dropdown-item'
                      onClick={this.handleLogout}
                    >
                      Đăng xuất
                    </button>
                  </div>
                </div>
              ) : (
                loading && (
                  <button
                    type='button'
                    className='btn_login flex-center'
                    data-toggle='modal'
                    data-target='#modal-login'
                  >
                    Đăng nhập
                  </button>
                )
              )}
            </div>
          </div>
          <div className='modal-navbar'></div>
        </nav>
      </header>
    );
  }
}
